import { LEARNING_SUBJECT } from 'utils/constants';

export const learningSubjectHasPinyin = (learningSubject) => {
  return learningSubject === LEARNING_SUBJECT.chineseMandarin.value;
};

export const learningSubjectIsChinese = (learningSubject) => {
  return [LEARNING_SUBJECT.chineseMandarin, LEARNING_SUBJECT.chineseCantonese].some(
    ({ value }) => learningSubject === value
  );
};
